/*
* GTM
*/
import { createGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin((nuxtApp) => {
  const confGtm =
    process.env.NODE_ENV === 'production' && useRuntimeConfig().public.confGlobal.serverType === 'PROD'
      ? useRuntimeConfig().public.confServices.gtm.live
      : useRuntimeConfig().public.confServices.gtm.dev

  const gtm = createGtm({
    id: confGtm.id,
    queryParams: {
      gtm_auth: confGtm.gtm_auth
    },
    defer: false,
    compatibility: false,
    enabled: confGtm.enabled,
    debug: confGtm.debug,
    loadScript: false,
    enableRouterSync: true,
    trackOnNextTick: false,
    devtools: true
  })

  // Update Cookies Consent
  nuxtApp.provide('setGtmConsent', (consentSettings) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'consent_update',
        functional: consentSettings.functional || false,
        performance: consentSettings.performance || false,
        analytics: consentSettings.analytics || false,
        others: consentSettings.others || false
      })
    }
  })

  nuxtApp.vueApp.use(gtm)
})